var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 17.083,
    viewBox: "0 0 17.083 17.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M7.54,352H.667a.667.667,0,0,0-.667.667v4a.667.667,0,0,0,.667.667H7.54a.667.667,0,0,0,.667-.667v-4A.667.667,0,0,0,7.54,352Zm-.667,4H1.335v-2.669H6.873Z",
    transform: "translate(0 -340.256)",
    fill: "#45338c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M7.54,0H.667A.667.667,0,0,0,0,.667V10.41a.667.667,0,0,0,.667.667H7.54a.667.667,0,0,0,.667-.667V.667A.667.667,0,0,0,7.54,0ZM6.873,9.743H1.335V1.335H6.873Z",
    fill: "#45338c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M273.54,0h-6.873A.667.667,0,0,0,266,.667v4a.667.667,0,0,0,.667.667h6.873a.667.667,0,0,0,.667-.667v-4A.667.667,0,0,0,273.54,0Zm-.667,4h-5.539V1.335h5.539Z",
    transform: "translate(-257.125)",
    fill: "#45338c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M273.54,180h-6.873a.667.667,0,0,0-.667.667v9.743a.667.667,0,0,0,.667.667h6.873a.667.667,0,0,0,.667-.667v-9.743A.667.667,0,0,0,273.54,180Zm-.667,9.743h-5.539v-8.408h5.539Z",
    transform: "translate(-257.125 -173.994)",
    fill: "#45338c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.fbb846369b336b5f10f1eec2644962ea.svg";
export { ForwardRef as ReactComponent };